<template>
    <div>
        {{ $t('notification.driveFolderRenamed', { 
            actor: $_.get(activity, 'actorUser.name'), 
            oldName: $_.get(activity, 'payload.oldName'),
            newName: $_.get(activity, 'payload.newName')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "DriveFolderRenamed",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

